module.exports = __webpack_public_path__ + "img/bbb4.7e986111.gif";